import {
  AlertCircle,
  AlertTriangle,
  BarChart3,
  CheckCircle,
  ClipboardList,
  Clock,
  Clock1,
  CreditCard,
  Database,
  DollarSign,
  FileText,
  GraduationCap,
  IdCard,
  Landmark,
  MapPin,
  NewspaperIcon,
  Repeat,
  Settings,
  SlidersHorizontal,
  Trophy,
  UploadCloud,
  User,
  User2,
  User2Icon,
  UserLock,
  UserMinus,
  Users,
} from "lucide-react";

const ICONS = {
  user: User,
  landmark: Landmark,
  users: Users,
  fileText: FileText,
  IdCard: IdCard,
  "Declaration Form": ClipboardList,
  Payment: CreditCard,
  "Exam Details": GraduationCap,
  Training: BarChart3,
  Discrepancy: AlertCircle,
  Certificate: Trophy,
  "Servicing Module": SlidersHorizontal,
  NOC: UserMinus,
} as const;

const SIDE_MENU = [
  {
    id: 1,
    name: "Masters",
    icon: Database,
    slug: "masters",
    submenus: [
      {
        id: 11,
        name: "Agent Master",
        slug: "agent-master",
        route: "agent-master",
        icon: User2,
        parent_id: 1,
      },
      {
        id: 12,
        name: "Transaction Master",
        slug: "transaction-master",
        route: "transaction-master",
        icon: CreditCard,
        parent_id: 1,
      },
      {
        id: 13,
        name: "Training Master",
        slug: "training-master",
        route: "training-master",
        icon: GraduationCap,
        parent_id: 1,
      },
      {
        id: 14,
        name: "IFSC Master",
        slug: "ifsc-master",
        route: "ifsc-master",
        icon: Settings,
        parent_id: 1,
      },
      {
        id: 15,
        name: "Pincode Master",
        slug: "pincode-master",
        route: "pincode-master",
        icon: MapPin,
        parent_id: 1,
      },
      {
        id: 16,
        name: "Stage Utility",
        slug: "utility-master",
        route: "utility-master",
        icon: Settings,
        parent_id: 1,
      },
      {
        id: 17,
        name: "Role-Based Charges",
        slug: "role-based-charges",
        route: "role-based-charges",
        icon: DollarSign,
        parent_id: 1,
      },
      {
        id: 18,
        name: "Exam-pending",
        slug: "exam-pending",
        route: "exam-pending",
        icon: Clock,
        parent_id: 1,
      },
      {
        id: 19,
        name: "Blacklisted Agents",
        slug: "blacklisted-agents",
        route: "blacklisted-agents",
        icon: null,
        parent_id: 1,
      },
      {
        id: 20,
        name: "Payment Receipt",
        slug: "payment-receipt-master",
        route: "payment-receipt-master",
        icon: null,
        parent_id: 1,
      },
      {
        id: 21,
        name: "Aging Discrepancy",
        slug: "aging-descrepancy",
        route: "aging-descrepancy",
        icon: null,
        parent_id: 1,
      },
      // {
      //   id: 32,
      //   name: "Reschedule Exam",
      //   slug: "reschedule-exam",
      //   route: "reschedule-exam",
      //   icon: null,
      //   parent_id: 1,
      // },
    ],
  },

  {
    id: 2,
    name: "User Management",
    icon: Users,
    slug: "user-management-list",
    submenus: [
      {
        id: 21,
        name: "Role Master",
        slug: "role-master",
        route: "role-master",
        icon: User2Icon,
        parent_id: 2,
      },
      {
        id: 22,
        name: "Access Control",
        slug: "access-control",
        route: "access-control",
        icon: UserLock,
        parent_id: 2,
      },
      {
        id: 23,
        name: "Create User",
        slug: "user-management",
        route: "create-user",
        icon: NewspaperIcon,
        parent_id: 2,
      },
    ],
  },
  {
    id: 3,
    name: "Reports",
    icon: FileText,
    slug: "reports",
    submenus: [
      {
        id: 31,
        name: "IRDAI Report",
        slug: "irdai-report",
        route: "irdai-report",
        icon: Repeat,
        parent_id: 3,
      },
    ],
  },
  {
    id: 4,
    name: "Bulk Upload",
    icon: UploadCloud,
    slug: "bulk-upload-list",
    submenus: [
      {
        id: 41,
        name: "Payment",
        slug: "payment-bulk-upload",
        route: "bulk-upload",
        icon: DollarSign,
        parent_id: 4,
      },
      {
        id: 42,
        name: "Agent Lead Upload",
        slug: "agent-lead-upload",
        route: "lead-upload",
        icon: User,
        parent_id: 4,
      },
      {
        id: 43,
        name: "Certified Agent",
        slug: "certified-agent-bulk-upload",
        route: "agent-bulk-upload",
        icon: User2,
        parent_id: 4,
      },
      {
        id: 44,
        name: "Exam Date",
        slug: "exam-date-bulk-upload",
        route: "exam-date-bulk-upload",
        icon: Clock1,
        parent_id: 4,
      },
      {
        id: 45,
        name: "Exam Result",
        slug: "exam-result-bulk-upload",
        route: "exam-result-bulk-upload",
        icon: Clock1,
        parent_id: 4,
      },
    ],
  },
  {
    id: 5,
    name: "Exam Config",
    slug: "exam-config-listing",
    route: "exam-config-listing",
    icon: null,
  },
  {
    id: 6,
    name: "Discrepency List",
    slug: "discrepency-list",
    route: "discrepancy-listing",
    icon: AlertTriangle,
  },

  {
    id: 7,
    name: "NOC List",
    slug: "noc-list",
    route: "noc",
    icon: CheckCircle,
  },
  {
    id: 8,
    name: "Servicing Module",
    slug: "servicing-module",
    submenus: [
      {
        id: 81,
        name: "Servicing Module",
        slug: "servicing-module",
        route: "servicing-module",
        icon: null,
        parent_id: 8,
      },

      {
        id: 82,
        name: "Actionable",
        slug: "status-tracking-actionable",
        route: "status-tracking-actionable",
        icon: null,
        parent_id: 8,
      },
      {
        id: 83,
        name: "Non Actionable",
        slug: "status-tracking-non-actionable",
        route: "status-tracking-non-actionable",
        icon: null,
        parent_id: 8,
      },
    ],
  },
  {
    id: 9,
    name: "Payment Waiver",
    slug: "payment-waiver",
    route: "payment-waiver",
    icon: DollarSign,
  },
  {
    id: 10,
    name: "Settings",
    slug: "settings",
    submenus: [
      {
        id: 101,
        name: "Menu Master",
        slug: "menu-master",
        route: "menu-master",
        icon: Database,
        parent_id: 9,
      },
      {
        id: 102,
        name: "Themes",
        slug: "theme-configuration",
        route: "theme",
        icon: Settings,
        parent_id: 10,
      },
    ],
  },
  {
    id: 11,
    name: "Reschedule Exam",
    slug: "reschedule-exam",
    submenus: [
      {
        id: 111,
        name: "Reschedule Exam",
        slug: "reschedule-exam",
        route: "reschedule-exam",
        icon: null,
        parent_id: 11,
      },
      {
        id: 112,
        name: "Reschedule Listing",
        slug: "reschedule-listing",
        route: "reschedule-listing",
        icon: null,
        parent_id: 11,
      },
      {
        id: 113,
        name: "Reschedule Raise",
        slug: "reschedule-raise",
        route: "reschedule-raise",
        icon: null,
        parent_id: 11,
      },
      // {
      //   id: 114,
      //   name : "Reschedule Approve",
      //   slug: "reschedule-approve",
      //   route: "reschedule-approve",
      //   icon: null,
      //   parent_id: 11,
      // },
    ],
  },
];

export { SIDE_MENU, ICONS };
